import { object, string, array, boolean } from 'yup';
import { AclAction } from 'shared/domains/apollo/generated/types';
const actions = array()
    .of(string().oneOf([AclAction.Read, AclAction.Write, AclAction.Delete, AclAction.Traverse]))
    .min(1)
    .required();
export const FileSystemManagerSchema = object({
    name: string().required(),
    parentId: string().nullable(),
    autoTag: boolean().required(),
    projects: array()
        .ensure()
        .of(object().shape({ id: string().required(), name: string().required() }))
        .required(),
    userAcls: array()
        .ensure()
        .of(object().shape({
        userId: string().required(),
        actions,
    }))
        .required(),
    teamAcls: array()
        .ensure()
        .of(object().shape({
        teamId: string().required(),
        actions,
    }))
        .required(),
});
